import React, { useCallback, useState } from 'react';
import { strOracleApiSender } from '@/utils/stroracle-api-sender';
import { DocumentModal } from '@/widgets/components/document-modal';
import styled from 'styled-components';

const ActivityDocumentLinkAnchor = styled.a`
  text-decoration: underline;
`;

export function ActivityDocumentLink({ activity, children }) {
  const { hasDocument, id } = activity;

  const [documentLinkPromise, setDocumentLinkPromise] = useState();

  const openDocument = useCallback(
    (e) => {
      e.preventDefault();

      setDocumentLinkPromise(
        (async () => {
          const { data = {} } = await strOracleApiSender.get(`/activity/${id}`);

          const { documentUrl } = data;

          if (documentUrl) {
            return documentUrl;
          }
          throw new Error('Failed to open document');
        })()
      );
    },
    [id]
  );

  if (!hasDocument) {
    return children;
  }

  return (
    <>
      <ActivityDocumentLinkAnchor href={'#'} onClick={openDocument}>
        {children}
      </ActivityDocumentLinkAnchor>
      <DocumentModal
        show={Boolean(documentLinkPromise)}
        onHide={() => setDocumentLinkPromise(null)}
        docLinkPromise={documentLinkPromise}
      />
    </>
  );
}
